import React from "react"
import { createPortal } from "react-dom"

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
  header?: string
  childrenClass?: string
  headerClass?: string
  headerTextClass?: string
  modalClass?: string
}

const Modal = ({
  isOpen = true,
  onClose,
  header = "",
  children = <></>,
  childrenClass = "",
  headerClass = "",
  headerTextClass = "",
  modalClass = "",
}: ModalProps) => {
  if (!isOpen) return null

  return createPortal(
    <div
      className="fixed inset-0 z-[9990] flex items-center justify-center"
      onClick={onClose}
    >
      <div className="fixed inset-0 bg-black/50" />
      <div
        className={`relative z-[9992] max-w-[800px] w-[90%] md:w-[70%] p-8 rounded-[24px] ${modalClass}`}
        onClick={(e) => e.stopPropagation()}
      >
        {header && (
          <div className={`flex justify-between ${headerClass}`}>
            <h1
              className={`text-xl md:text-2xl text-center font-bold ${headerTextClass}`}
            >
              {header}
            </h1>
          </div>
        )}
        <div className={`max-w-[400px] mx-auto ${childrenClass}`}>
          {children}
        </div>
      </div>
    </div>,
    document.body,
  )
}

export default Modal
